// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"UserDocumentRequests_wrapper__K0cKu"};